(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ProcessType', ProcessType);

    ProcessType.$inject = ['$resource'];

    function ProcessType ($resource) {
        var resourceUrl =  'api/process-types';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
